import { ReactNode } from "react";

import { Box, Stack, useTheme } from "@mui/material";

import { useDynamicThemeAwareVariables } from "@/features/FormV2/hooks/useDynamicThemeAwareVariables";
import { FormTypography } from "@/forms-design-system/FormTypography";

type BasePeerToPeerCampaignActionProps = {
  title: string;
  description: string;
  slots: {
    button: ReactNode;
  };
};

export const BasePeerToPeerCampaignAction = ({ title, description, slots }: BasePeerToPeerCampaignActionProps) => {
  const theme = useTheme();

  const { titleColor, descriptionColor, backgroundColor } = useDynamicThemeAwareVariables(({ mode, formsPalette }) => ({
    titleColor: mode === "light" ? formsPalette.text.brand : formsPalette.text.intense,
    descriptionColor: mode === "light" ? formsPalette.text.brand : formsPalette.text.moderate,
    backgroundColor: formsPalette.surface.quiet,
  }));

  return (
    <Stack
      direction={{ sm: "row" }}
      gap={2}
      alignItems={{ xs: "flex-start", sm: "center" }}
      width="100%"
      padding={theme.spacing(1.5, 2)}
      sx={{
        backgroundColor,
        borderRadius: theme.spacing(1),
        boxSizing: "border-box",
      }}
    >
      <Box flex={{ sm: "1 1 auto" }}>
        <FormTypography variant="subtitle1" color={titleColor}>
          {title}
        </FormTypography>
        <FormTypography variant="body2" color={descriptionColor}>
          {description}
        </FormTypography>
      </Box>
      {slots.button}
    </Stack>
  );
};
